import { CoreMenuItem, CoreSelect, OverflowText } from "@verity/components/core";
import { SessionInfo } from "../../../TestResultsWrapper";
import i18n from "../../../../../i18n";
import SessionStatusChip from "./StatusChip";
import dropdownStyles from "./SelectorDropdown.module.css";

type AttemptSelectorNewProps = {
	sessionNumber: number;
	onChange: (value: number) => void;
	proctoringSessions: SessionInfo[];
	className?: string;
};

function AttemptOptionDisplay({ label, status }: { label: string; status?: string | null }) {
	return (
		<div className={dropdownStyles.optionDisplay}>
			<OverflowText className={dropdownStyles.valueLabel}>{label}</OverflowText>
			<span className={dropdownStyles.valueBadge}>
				<SessionStatusChip status={status} />
			</span>
		</div>
	);
}

export default function AttemptSelectorNew({
	sessionNumber,
	onChange,
	proctoringSessions,
	className,
}: AttemptSelectorNewProps) {
	const totalSessions = proctoringSessions.length;

	return (
		<div className={dropdownStyles.labelWrapper}>
			<span className={dropdownStyles.label}>
				{i18n.t("result.components.resultsPage.proctoringResultsViewTSX.attemptSelectorLabel")}
			</span>
			<div className={`${dropdownStyles.container} ${className || ""}`} style={{ width: "250px" }}>
				<CoreSelect<number>
					className={dropdownStyles.dropdown}
					value={sessionNumber - 1} // sessionNumber is 1-indexed, but the select value should be 0-indexed
					onChange={(event) => {
						const index = Number(event.target.value);
						onChange(index);
					}}
					label={i18n.t("result.components.resultsPage.proctoringResultsViewTSX.attemptSelectorLabel") as string}
					renderValue={() => (
						<AttemptOptionDisplay
							label={i18n.t("result.components.resultsPage.proctoringResultsViewTSX.attempt", {
								current: sessionNumber,
								total: totalSessions,
							}) as string}
							status={proctoringSessions[sessionNumber - 1]?.status}
						/>
					)}
					MenuProps={{
						MenuListProps: {
							onKeyDown: (event) => {
								if (event.key === "Tab") {
									event.stopPropagation(); // Allows tab navigation
								}
							},
						},
					}}
				>
					{proctoringSessions.map((session, index) => (
						<CoreMenuItem key={index} value={index}>
							<AttemptOptionDisplay
								label={i18n.t("result.components.resultsPage.proctoringResultsViewTSX.attempt2", {
									attempt: index + 1,
									total: totalSessions,
								}) as string}
								status={session.status}
							/>
						</CoreMenuItem>
					))}
				</CoreSelect>
			</div>
		</div>
	);
}
